import React, { useState } from "react";
import axios from "axios";
import "./accountDeletion.css";

const AccountDeletion = () => {
  const [formData, setFormData] = useState({
    email: "",
    reason: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    type: "",
    text: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,                                   
      [name]: value,
    }));

    // Clear previous messages
    setMessage({
      type: "",
      text: "",
    });
  };

  // Basic validation
  const validateForm = () => {
    if (!formData.email.trim()) {
      setMessage({
        type: "error",
        text: "Email is required.",
      });
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setMessage({
        type: "error",
        text: "Please enter a valid email address.",
      });
      return false;
    }

    if (!formData.reason.trim()) {
      setMessage({
        type: "error",
        text: "Reason for account deletion is required.",
      });
      return false;
    }

    if (formData.reason.trim().length < 10) {
      setMessage({
        type: "error",
        text: "Reason must be at least 10 characters long.",
      });
      return false;
    }

    return true;
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const response = await axios.post(
        "/api/account-deletion/request",
        formData
      );

      setMessage({
        type: "success",
        text:
          response.data.message ||
          "Your account deletion request has been submitted successfully.",
      });

      // Reset form
      setFormData({
        email: "",
        reason: "",
      });
    } catch (error) {
      setMessage({
        type: "error",
        text:
          error.response?.data?.message ||
          "Failed to submit account deletion request. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-deletion-container">
      <div className="account-deletion-card">
        <div className="account-deletion-header">
          <h2>Request Account Deletion</h2>
          <p>
            Submit your email and reason for deleting your account. Our admin
            team will review your request.
          </p>
        </div>

        {message.text && (
          <div className={`account-message ${message.type}`}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="account-deletion-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your registered email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="reason">Reason for Account Deletion</label>
            <textarea
              id="reason"
              name="reason"
              placeholder="Please explain why you want to delete your account..."
              rows="5"
              value={formData.reason}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Deletion Request"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccountDeletion; 